// 對應 CRM.Domain.EnumType.TryInstallDivideType 的列舉
export class TryInstallDivideType {
  static get TryInstallRemove () {
    return 1 // 拆品項
  }
  static get TryInstallChange () {
    return 2 // 轉新良品
  }
  static get TryInstallOriginal () {
    return 3 // 原品項
  }

  static TryInstallDivideTypeName (type) {
    let tmpType = parseInt(type)
    let value = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (value) {
      case 1:
        name = '拆品項'
        break
      case 2:
        name = '轉新良品'
        break
      case 3:
        name = '原品項'
        break
    }
    return name
  }
}
